import api from './api';
import { MAX_ITENS_POR_PROTOCOLO } from '../constants/protocolo';

const getTotaisProtocolo = async () => {
  try {
    const client = await api('protocolo');
    const { data } = await client.post('consulta/exec/totais-protocolo');
    return data[0] && data[0].contratos ? data[0].contratos : MAX_ITENS_POR_PROTOCOLO;
  } catch (e) {
    return MAX_ITENS_POR_PROTOCOLO;
  }
};

export {
  getTotaisProtocolo,
};
